import React, { useState } from "react";

import Table from "components/Table";
import Filter from "@Components/Filter";

let model = [
  { id: "device_type", label: "Device Type", type: "string" },
  { id: "version", label: "App Version", type: "string" },
  {
    id: "force_update",
    label: "Force Update",
    type: "boolean",
    yesValue: "Yes",
    noValue: "No",
  },
];

const actions = ["edit", "delete"];

const filterFields = [
  {
    type: "reactselect",
    label: "Device Type",
    name: "device_type",
    outerOptions: [
      { id: "Android", name: "Android" },
      { id: "IOS", name: "IOS" },
    ],
  },
  {
    type: "reactselect",
    label: "Force Update",
    name: "force_update",
    outerOptions: [
      { id: "1", name: "Yes" },
      { id: "0", name: "No" },
    ],
  },
  {
    type: "input",
    label: "App Version",
    name: "version",
  },
];

const filterInitialValues = {
  device_type: "",
  version: "",
  force_update: 0,
};

const ForceUpdate = () => {
  const [filterValues, setFilterValues] = useState({});

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL="force-update/"
        model={model}
        actions={actions}
        exportUrl="url"
        qqq
        filterValues={filterValues}
        noFilter
      />
    </>
  );
};
export default ForceUpdate;
